import { Outlet } from 'react-router-dom'

const Partner = () => <Outlet />

export default Partner
